document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('[data-lp-accordion-group]').forEach(function (group) {
    var allowMultiple = group.getAttribute('data-lp-accordion-group') === 'multiple';
    group.addEventListener('click', function (e) {
      var head = e.target.closest('[data-lp-accordion-head]');
      if (!head) return;
      var item = head.closest('[data-lp-accordion-item]');
      var wasOpen = item.classList.contains('lp-open');

      if (!allowMultiple) {
        group.querySelectorAll('[data-lp-accordion-item]').forEach(function (i) {
          i.classList.remove('lp-open');
          var icon = i.querySelector('[data-lp-accordion-icon]');
          if (icon) icon.textContent = '+';
        });
      }
      if (!wasOpen) {
        item.classList.add('lp-open');
        var icon = item.querySelector('[data-lp-accordion-icon]');
        if (icon) icon.textContent = '—';
      } else {
        item.classList.remove('lp-open');
        var icon2 = item.querySelector('[data-lp-accordion-icon]');
        if (icon2) icon2.textContent = '+';
      }
    });
  });

  /* Menu mobile (bouton ☰) : ouvre/ferme le panneau de navigation mobile */
  document.querySelectorAll('[data-lp-burger]').forEach(function (burger) {
    burger.addEventListener('click', function () {
      var nav = document.querySelector('[data-lp-mobile-nav]');
      if (!nav) return;
      var isOpen = nav.classList.toggle('lp-show');
      nav.style.display = isOpen ? 'block' : 'none';
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      burger.textContent = isOpen ? '✕' : '☰';
    });
  });
  document.querySelectorAll('[data-lp-mobile-nav] a').forEach(function (link) {
    link.addEventListener('click', function () {
      var nav = document.querySelector('[data-lp-mobile-nav]');
      var burger = document.querySelector('[data-lp-burger]');
      if (nav) { nav.classList.remove('lp-show'); nav.style.display = 'none'; }
      if (burger) { burger.textContent = '☰'; burger.setAttribute('aria-expanded', 'false'); }
    });
  });

  document.querySelectorAll('[data-lp-db-demo]').forEach(function (demo) {
    var waveform = demo.querySelector('[data-lp-waveform]');
    var slider = demo.querySelector('[data-lp-db-slider]');
    var valueEl = demo.querySelector('[data-lp-db-value]');
    if (!waveform || !slider) return;

    var bars = 28;
    for (var i = 0; i < bars; i++) {
      var s = document.createElement('span');
      s.style.height = (10 + Math.random() * 24) + 'px';
      waveform.appendChild(s);
    }

    var minDb = parseInt(slider.getAttribute('data-min-db'), 10) || 6;
    var maxDb = parseInt(slider.getAttribute('data-max-db'), 10) || 30;

    function update(val) {
      var pct = val / 100;
      var db = Math.round(minDb + pct * (maxDb - minDb));
      if (valueEl) valueEl.textContent = db + ' dB';
      var spans = waveform.querySelectorAll('span');
      spans.forEach(function (s, i) {
        var base = 6 + Math.sin(i * 0.7) * 10 + 14;
        s.style.height = Math.max(3, base * (1 - pct * 0.75)) + 'px';
      });
    }
    slider.addEventListener('input', function () { update(this.value); });
    update(slider.value);
  });

  document.querySelectorAll('[data-lp-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-lp-gallery-main]');
    gallery.querySelectorAll('[data-lp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = this.getAttribute('data-full-src');
        if (mainImg && src) mainImg.src = src;
        gallery.querySelectorAll('[data-lp-thumb]').forEach(function (t) { t.classList.remove('lp-active'); });
        this.classList.add('lp-active');
      });
    });

    /* Zoom plein écran (tap/clic sur la photo principale) : ouvre une visionneuse
       distraction-free avec l'image actuellement affichée. Se ferme au tap sur la
       croix, en dehors de l'image, ou avec la touche Échap. */
    var zoomTrigger = gallery.querySelector('[data-lp-zoom-trigger]');
    var overlay = gallery.querySelector('[data-lp-zoom-overlay]');
    var zoomImg = overlay ? overlay.querySelector('[data-lp-zoom-img]') : null;
    var zoomClose = overlay ? overlay.querySelector('[data-lp-zoom-close]') : null;

    function openZoom() {
      if (!overlay || !zoomImg || !mainImg) return;
      zoomImg.src = mainImg.src;
      zoomImg.alt = mainImg.alt || '';
      overlay.classList.add('lp-show');
      document.body.style.overflow = 'hidden';
    }
    function closeZoom() {
      if (!overlay) return;
      overlay.classList.remove('lp-show');
      document.body.style.overflow = '';
    }

    if (zoomTrigger) zoomTrigger.addEventListener('click', openZoom);
    if (zoomClose) zoomClose.addEventListener('click', closeZoom);
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeZoom();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeZoom();
    });
  });

  /* Bouton "Voir tous les avis" : déplie les avis au-delà des 9 premiers, sans recharger la page */
  document.querySelectorAll('[data-lp-reviews-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var section = btn.closest('.lp-reviews-section');
      if (!section) return;
      section.querySelectorAll('[data-lp-review-extra]').forEach(function (card) {
        card.style.display = '';
      });
      btn.style.display = 'none';
    });
  });

  document.querySelectorAll('[data-lp-product-form]').forEach(function (formWrap) {
    var variantsJson = formWrap.querySelector('[data-lp-variants-json]');
    if (!variantsJson) return;
    var variants;
    try { variants = JSON.parse(variantsJson.textContent); } catch (e) { return; }

    var idInput = formWrap.querySelector('input[name="id"]');
    var priceEl = formWrap.querySelector('[data-lp-price]');
    var comparePriceEl = formWrap.querySelector('[data-lp-compare-price]');
    var addBtn = formWrap.querySelector('[data-lp-add-btn]');
    var stickyBtn = document.querySelector('[data-lp-sticky-add-btn]');
    var stockFlag = formWrap.querySelector('[data-lp-stock-flag]');
    var mainImg = formWrap.querySelector('[data-lp-gallery-main]');

    var selected = {};
    formWrap.querySelectorAll('[data-lp-option-index]').forEach(function (group) {
      var active = group.querySelector('.lp-active');
      if (active) selected[group.getAttribute('data-lp-option-index')] = active.getAttribute('data-value');
    });

    function findMatch() {
      return variants.find(function (v) {
        return Object.keys(selected).every(function (idx) {
          return v.options[idx] === selected[idx];
        });
      });
    }

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    var lastImageSrc = null;

    function refresh() {
      var match = findMatch();
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (comparePriceEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          comparePriceEl.textContent = formatMoney(match.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      if (match.featured_image && match.featured_image.src) {
        var newSrc = match.featured_image.src;
        if (newSrc !== lastImageSrc) {
          lastImageSrc = newSrc;
          if (mainImg) mainImg.src = newSrc;
          formWrap.querySelectorAll('[data-lp-thumb]').forEach(function (t) {
            var thumbSrc = t.getAttribute('data-full-src') || '';
            var isMatch = thumbSrc.split('?')[0] === newSrc.split('?')[0];
            t.classList.toggle('lp-active', isMatch);
          });
        }
      }

      var available = match.available;
      [addBtn, stickyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
        btn.textContent = available
          ? btn.getAttribute('data-label-available')
          : btn.getAttribute('data-label-sold-out');
      });
      if (stockFlag) {
        if (available && match.inventory_management && match.inventory_quantity > 0 && match.inventory_quantity <= 10) {
          stockFlag.style.display = '';
          stockFlag.textContent = stockFlag.getAttribute('data-label-template').replace('[[count]]', match.inventory_quantity);
        } else if (!available) {
          stockFlag.style.display = '';
          stockFlag.textContent = stockFlag.getAttribute('data-label-sold-out');
        } else {
          stockFlag.style.display = 'none';
        }
      }
      formWrap.querySelectorAll('[data-lp-option-index]').forEach(function (group) {
        var idx = group.getAttribute('data-lp-option-index');
        group.querySelectorAll('[data-value]').forEach(function (opt) {
          var testSelection = Object.assign({}, selected);
          testSelection[idx] = opt.getAttribute('data-value');
          var stillAvailable = variants.some(function (v) {
            return Object.keys(testSelection).every(function (i) { return v.options[i] === testSelection[i]; }) && v.available;
          });
          opt.disabled = !stillAvailable;
        });
      });
    }

    formWrap.querySelectorAll('[data-lp-option-index]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-value]');
        if (!opt || opt.disabled) return;
        var idx = group.getAttribute('data-lp-option-index');
        selected[idx] = opt.getAttribute('data-value');
        group.querySelectorAll('[data-value]').forEach(function (o) { o.classList.remove('lp-active'); });
        opt.classList.add('lp-active');

        var optionBlock = group.closest('.lp-option-block') || group.closest('.lp-bundle-item-info') || group.parentElement;
        var labelTarget = optionBlock ? optionBlock.querySelector('[data-lp-selected-label]') : null;
        if (labelTarget) labelTarget.textContent = opt.getAttribute('data-value');

        var bundleItem = group.closest('.lp-bundle-item');
        var imgUrl = opt.getAttribute('data-image');
        var imgUrlLarge = opt.getAttribute('data-image-large');
        if (bundleItem && imgUrl) {
          var itemImg = bundleItem.querySelector('.lp-bundle-item-img img');
          if (itemImg) itemImg.src = imgUrl;
          if (mainImg && imgUrlLarge) mainImg.src = imgUrlLarge;
        }

        refresh();
      });
    });

    refresh();

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var realForm = formWrap.querySelector('form[action^="/cart/add"]');
        if (realForm) realForm.querySelector('[data-lp-add-btn]').click();
      });
    }

    var buyNowBtn = formWrap.querySelector('[data-lp-buy-now]');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        var realForm = formWrap.querySelector('form[action^="/cart/add"]');
        if (!realForm) return;
        var originalText = buyNowBtn.textContent;
        buyNowBtn.disabled = true;
        buyNowBtn.textContent = '...';
        var formData = new FormData(realForm);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        }).then(function () {
          window.location.href = '/checkout';
        }).catch(function () {
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = originalText;
          window.location.href = '/checkout';
        });
      });
    }
  });

  var stickyBar = document.querySelector('[data-lp-sticky-bar]');
  var trigger = document.querySelector('[data-lp-sticky-trigger]');
  if (stickyBar && trigger) {
    if (stickyBar.parentElement !== document.body) {
      document.body.appendChild(stickyBar);
    }
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('lp-show', scrolledPast);
      }, { threshold: 0 });
      observer.observe(trigger);
    } else {
      window.addEventListener('scroll', function () {
        var rect = trigger.getBoundingClientRect();
        stickyBar.classList.toggle('lp-show', rect.bottom < 0);
      });
    }
  }

  document.querySelectorAll('[data-lp-newsletter-form]').forEach(function (form) {
    if (form.querySelector('.lp-newsletter-success')) {
      form.style.display = 'none';
      var successEl = form.parentElement.querySelector('[data-lp-newsletter-success-msg]');
      if (successEl) successEl.style.display = 'block';
    }
  });

});
